/* MAG Signature Sound — Track Insight Gateway customer-state actions
   v2 — Locksmith-first customer authentication
*/
(function () {
  'use strict';

  var DASHBOARD_URL = '/pages/track-insight-dashboard';
  var UPLOAD_URL = '/pages/track-insight-upload';

  function gatewayRoots() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[id^="TrackInsightGateway-"]')
    );
  }

  function waitForCustomer(timeoutMs) {
    timeoutMs = timeoutMs || 10000;

    return new Promise(function (resolve, reject) {
      var started = Date.now();

      function check() {
        if (
          window.TrackInsightCustomer &&
          typeof window.TrackInsightCustomer.getSession === 'function' &&
          typeof window.TrackInsightCustomer.listSubmissions === 'function'
        ) {
          resolve(window.TrackInsightCustomer);
          return;
        }

        if (Date.now() - started >= timeoutMs) {
          reject(
            new Error(
              'Track Insight customer connection did not load.'
            )
          );
          return;
        }

        window.setTimeout(check, 80);
      }

      check();
    });
  }

  function normaliseStatus(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }

  function deriveState(submissions) {
    submissions = Array.isArray(submissions)
      ? submissions
      : [];

    var awaiting = submissions.find(function (item) {
      return (
        normaliseStatus(item.status) ===
        'awaiting upload'
      );
    });

    if (awaiting) {
      return {
        key: 'awaiting_upload',
        label: 'UPLOAD YOUR TRACK',
        lowerLabel:
          'Already purchased? Upload your track →',
        href:
          UPLOAD_URL +
          '?submission=' +
          encodeURIComponent(awaiting.id)
      };
    }

    var active = submissions.find(function (item) {
      var status = normaliseStatus(item.status);

      return (
        status === 'submitted' ||
        status === 'in review' ||
        status === 'reviewing'
      );
    });

    if (active) {
      return {
        key: 'active',
        label: 'VIEW YOUR TRACK INSIGHT',
        lowerLabel:
          'View your active Track Insight →',
        href: DASHBOARD_URL
      };
    }

    var completed = submissions.find(function (item) {
      var status = normaliseStatus(item.status);

      return (
        status === 'complete' ||
        status === 'completed'
      );
    });

    if (completed) {
      return {
        key: 'completed',
        label: 'VIEW MY TRACK INSIGHTS',
        lowerLabel:
          'View my Track Insights →',
        href: DASHBOARD_URL
      };
    }

    return {
      key: 'none',
      label: 'NO TRACK INSIGHTS YET',
      lowerLabel:
        'No Track Insights found on this account',
      href: '#'
    };
  }

  /*
    IMPORTANT:
    When there is no private Track Insight session yet, we do NOT start
    Customer Account API OAuth from the public gateway.

    Instead, the customer is sent directly to the Locksmith-protected
    Track Insight dashboard.

    Locksmith / Shopify establishes the storefront customer login first.
    Once the dashboard is accessible, track-insight-dashboard-live.js
    automatically establishes the private Track Insight OAuth session.

    This prevents the customer being asked to sign in twice.
  */
  function signedOutState() {
    return {
      key: 'signed_out',
      label:
        'ALREADY PURCHASED? SIGN IN TO CONTINUE',
      lowerLabel:
        'Already purchased? Sign in to get your Track Insights →',
      href: DASHBOARD_URL
    };
  }

  function setButtonText(button, text) {
    if (!button) return;

    var span = button.querySelector('span');

    if (span) {
      span.textContent = text;
    } else {
      button.textContent = text;
    }
  }

  function applyState(root, state) {
    root.dataset.tiGatewayCustomerState =
      state.key;

    var heroButton =
      root.querySelector(
        '.tig__button--secondary'
      );

    var lowerLink =
      root.querySelector(
        '.tig__existing-link'
      );

    if (heroButton) {
      setButtonText(
        heroButton,
        state.label
      );

      heroButton.setAttribute(
        'href',
        state.href || '#'
      );

      heroButton.dataset.tiGatewayAction =
        state.key;
    }

    if (lowerLink) {
      lowerLink.textContent =
        state.lowerLabel;

      lowerLink.setAttribute(
        'href',
        state.href || '#'
      );

      lowerLink.dataset.tiGatewayAction =
        state.key;
    }
  }

  async function resolveState(customer) {
    var session = null;

    try {
      session =
        await customer.getSession();
    } catch (_) {
      /*
        A stale private Track Insight session should not stop the
        customer reaching Shopify / Locksmith authentication.
      */
      try {
        customer.clearSession();
      } catch (_) {}

      return signedOutState();
    }

    /*
      No Track Insight OAuth session exists yet.

      Send the customer to the Locksmith-protected dashboard instead
      of initiating OAuth here.
    */
    if (!session) {
      return signedOutState();
    }

    try {
      var submissions =
        await customer.listSubmissions();

      return deriveState(submissions);
    } catch (_) {
      /*
        If the private session is no longer usable, clear it and fall
        back to the normal Locksmith-first login journey.
      */
      try {
        customer.clearSession();
      } catch (_) {}

      return signedOutState();
    }
  }

  function bind(root) {
    if (
      root.dataset.tiGatewayStateBound ===
      'true'
    ) {
      return;
    }

    root.dataset.tiGatewayStateBound =
      'true';

    root.addEventListener(
      'click',
      function (event) {
        var target =
          event.target.closest(
            '.tig__button--secondary, .tig__existing-link'
          );

        if (
          !target ||
          !root.contains(target)
        ) {
          return;
        }

        var action =
          target.dataset.tiGatewayAction;

        /*
          SIGNED OUT
          ------------

          Do NOT prevent the normal link.

          The href points directly to the Track Insight dashboard,
          which Locksmith protects.

          Locksmith therefore handles Shopify customer authentication
          before the Track Insight OAuth hand-off begins.
        */
        if (action === 'signed_out') {
          return;
        }

        /*
          EXISTING PRIVATE SESSION BUT NO TRACK INSIGHT PURCHASE

          Keep the customer on this public page and move them towards
          the purchase options.
        */
        if (action === 'none') {
          event.preventDefault();

          var pricing =
            document.getElementById(
              'track-insight-pricing'
            );

          if (pricing) {
            pricing.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            return;
          }

          var buy =
            root.querySelector(
              '[data-ti-buy-now]'
            );

          if (buy) {
            buy.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }
      }
    );
  }

  async function initRoot(root) {
    if (
      !root ||
      root.dataset.tiGatewayStateReady ===
        'true'
    ) {
      return;
    }

    root.dataset.tiGatewayStateReady =
      'true';

    /*
      Safe initial state.

      The public gateway never needs to force a customer OAuth login.
    */
    applyState(
      root,
      signedOutState()
    );

    try {
      var customer =
        await waitForCustomer();

      bind(root);

      var state =
        await resolveState(customer);

      applyState(
        root,
        state
      );
    } catch (error) {
      console.error(
        '[Track Insight Gateway state]',
        error
      );

      /*
        Even if the customer-state script fails, the returning customer
        can still reach the Locksmith-protected dashboard.
      */
      applyState(
        root,
        signedOutState()
      );

      bind(root);
    }
  }

  function start() {
    gatewayRoots().forEach(
      initRoot
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener(
    'shopify:section:load',
    start
  );
})();